export class AttachmentApi {
    download(idx: number): void {
        window.open(ENV.BASE_API_PATH + '/attachment/download/' + idx, '_blank');
    }
}
